import { EMPTY_DATA_PLACEHOLDER } from "@/utils/constants"

export const formatIntervalMeterSeriesLabel = (
  formatFlowDirection: (value: string | null | undefined) => string,
  flowDirection: string | null | undefined,
  meterLabel: string,
  showFlowDirection: boolean
): string => {
  if (meterLabel === "" || !showFlowDirection) {
    return meterLabel
  }

  const flowLabel = formatFlowDirection(flowDirection)
  if (flowLabel === "" || flowLabel === EMPTY_DATA_PLACEHOLDER) {
    return meterLabel
  }

  return `${meterLabel}-${flowLabel}`
}
